export { default } from './CommentsIn';



// WEBPACK FOOTER //
// ./src/components/Comment/ReducerWrappers/CommentsIn/index.js